import { categorySlider } from './functions/splideSlider';
import { toggleHeight } from './functions/utilityFunctions';

document.addEventListener('DOMContentLoaded', () => {
  // スライダー
  categorySlider();

  // もっと見るボタン(9位まで)
  let device = '';
  const moreButton = document.getElementById('js-rankingButton');

  if (moreButton) {
    // moreButtonが存在するか確認
    const targetId = moreButton.getAttribute('data-target');
    const target = document.getElementById(targetId);
    const hasGenre = target ? target.querySelector('.l-category__ranking-title') !== null : false;

    const resizeHandler = () => {
      if (window.matchMedia('(min-width: 768px)').matches) {
        if (device !== 'pc') {
          device = 'pc';
          const height = hasGenre ? 212 : 161;
          toggleHeight(moreButton, height);
        }
      } else {
        if (device !== 'mobile') {
          device = 'mobile';
          const height = hasGenre ? 256 : 209;
          toggleHeight(moreButton, height);
        }
      }
    };

    // 初期化とリサイズイベントの設定
    resizeHandler();
    window.addEventListener('resize', resizeHandler);
  }

  // もっと見るボタン(12位まで)
  let currentdevice = '';
  const moreButton12 = document.getElementById('js-rankingButton-12');

  if (moreButton12) {
    // moreButton12が存在するか確認
    const resizeHandler12 = () => {
      if (window.matchMedia('(min-width: 768px)').matches) {
        if (currentdevice !== 'pc') {
          currentdevice = 'pc';
          toggleHeight(moreButton12, 215);
        }
      } else {
        if (currentdevice !== 'mobile') {
          currentdevice = 'mobile';
          toggleHeight(moreButton12, 209);
        }
      }
    };

    // 初期化とリサイズイベントの設定
    resizeHandler12();
    window.addEventListener('resize', resizeHandler12);
  }

  // ランキングのクラス切り替え（最後の行にクラスを付与）
  const target = moreButton ? document.getElementById(moreButton.getAttribute('data-target')) : null;
  if (target) {
    setRankingClass(target);
  }

  const tagList = document.getElementById('js-tagPullDown');
  if (tagList) {
    toggleHeight(tagList, 106);
  }

  // タブごとのリスト表示切り替え
  const handleChangeSlider = (tab) => {
    tab.addEventListener('change', () => {
      const targetId = tab.getAttribute('data-target');
      const target = document.getElementById(targetId);
      const sliders = tab.closest('.l-category__article').querySelectorAll('.l-category__slider');

      if (target) {
        sliders.forEach((slider) => {
          slider.classList.remove('is-active');
        });
        target.classList.add('is-active');
      }
    });
  };

  const categoryRankingTabs = document.querySelectorAll('.js-categoryRanking');
  categoryRankingTabs.forEach((tab) => {
    handleChangeSlider(tab);
  });
  const cheapListTabs = document.querySelectorAll('.js-cheapList');
  cheapListTabs.forEach((tab) => {
    handleChangeSlider(tab);
  });
  const newListTabs = document.querySelectorAll('.js-newList');
  newListTabs.forEach((tab) => {
    handleChangeSlider(tab);
  });
});

const setRankingClass = (target) => {
  const items = target.querySelectorAll('ul');

  if (!items.length) return;

  items.forEach((item) => {
    const li = item.querySelectorAll('li');
    const column = 3;

    li.forEach((element) => element.classList.remove('is-last'));

    const totalItems = li.length;
    const lastRowStart = Math.floor((totalItems - 1) / column) * column;

    for (let i = lastRowStart; i < totalItems; i++) {
      li[i].classList.add('is-last');
    }
  });
};
